module.exports = __webpack_public_path__ + "static/mo30-754991f3ef35f78f458a5b91f49d56f7.png";